import { render, staticRenderFns } from "./SmallStatModal.vue?vue&type=template&id=72740c34"
import script from "./SmallStatModal.vue?vue&type=script&lang=js"
export * from "./SmallStatModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports